import { render, staticRenderFns } from "./AchAggregateFeeReductionRewardEditor.vue?vue&type=template&id=1c6aa378&scoped=true"
import script from "./AchAggregateFeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./AchAggregateFeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6aa378",
  null
  
)

export default component.exports